import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import RouteModel from "../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";

export class LocateRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "locate_route_id";
    choiceOrder: string[] = ["page_list", "map"];
    goToFirstChild : boolean = true;
}

export default class LocateRouteFactory extends RouteFactory
{

    id: FactoryID = "locate_route";

    constructor()
    {
        super();

        this.choices = {
            page_list: new RouteChoice({
                publicID: "list",
                name: "By name",
                nextFactoryID: "locate_page_list_route"
            }),
            map: new RouteChoice({
                name: "On map"
            })
        }
    }

    birth(id: FactoryID): LocateRouteModel
    {
        return new LocateRouteModel(id);
    }

    getDefaultModel(): LocateRouteModel
    {
        return this.getDefaultModelWithRoute()! as LocateRouteModel;
    }
}